import axios from 'axios';
import lib from '@/lib';

export default class TimedNotificationsModel {
	constructor() {
		this.show = true;
		
		this.list = [
			{
				type: 'disabled',
				icon: 'notification_systemMessage_medium_flat_black',
				time: ((((0 * 60) + 19) * 60) + 43) * 1000,
				expireTime: 0,
				title: 'Отключение сервера в 16:00 (GMT +06:00)<br/>Отключение сервера для заливки обновлений.<br/>Избегайте массовых боев и штурмов.',
				count: 0,
				onClick: () => {},
			},
			{
				type: 'clickable',
				icon: 'notification_systemMessage_medium_flat_black',
				time: ((((22 * 60) + 19) * 60) + 43) * 1000,
				expireTime: 0,
				title: 'Важное системное сообщение',
				count: 0,
				onClick: () => {
					this.$router.push({path: '/system-message'});
				},
			},
			{
				type: 'clickable',
				icon: 'notification_systemMessageAnnounce_medium_flat_black',
				time: ((((22 * 60) + 19) * 60) + 43) * 1000,
				expireTime: 0,
				title: 'Объявление',
				count: 0,
				onClick: () => {
					this.$router.push({path: '/system-message-2'});
				},
			},
			/*{
				type: 'disabled',
				icon: 'notification_relocationCooldown_medium_flat_black',
				time: ((((((0 * 24) + 12) * 60) + 0) * 60) + 0) * 1000,
				expireTime: 0,
				title: 'Ты только что переехал и не можешь атаковать других игроков до 11:54:23',
				count: 0,
				onClick: () => {},
			},
			{
				type: 'disabled',
				icon: 'feature_beginnersProtection_medium_flat_black',
				time: ((((((6 * 24) + 1) * 60) + 0) * 60) + 0) * 1000,
				expireTime: 0,
				title: 'Ты будешь находиться под защитой еще 119:15:41.<br/>Внимание: Защита также спадет, как только ты достигнешь населения 200!',
				count: 0,
				onClick: () => {},
			},
			{
				type: 'disabled',
				icon: 'feature_natars_medium_flat_black',
				time: ((((((6 * 24) + 1) * 60) + 0) * 60) + 0) * 1000,
				expireTime: 0,
				title: 'Чудеса света появятся через 67:10:35',
				count: 0,
				onClick: () => {},
			},
			{
				type: 'clickable',
				icon: 'notification_goldPromotion_medium_flat_black',
				time: ((((((6 * 24) + 1) * 60) + 0) * 60) + 0) * 1000,
				expireTime: 0,
				title: 'Распродажа (+30%): 1д 08ч 57м 30с',
				count: 0,
				onClick: () => {
					this.$router.push({path: '/shop'});
				},
			},
			{
				type: 'clickable',
				icon: 'notification_halloweenGameWorld_medium_flat_black',
				time: 0,
				expireTime: 0,
				title: 'Принимайте участие в специальном жутком испытании на Хеллоуин и получайте замечательные награды.',
				count: 1,
				onClick: () => {
					//this.$router.push({path: '/gameWorld'});
				},
			},*/
			/*<a ng-repeat="n in notifications.data | orderBy:'data.time':true" class="notification clickable" ng-class="{disabled: !isClickable(n.data.type)}" clickable="openNotification(104)" tooltip="" tooltip-translate="Notification_104" tooltip-data="expireTime:0,data:" tooltip-placement="above" ng-if="n.data.time < currentServerTime && (n.data.expireTime == 0 || n.data.expireTime > currentServerTime)">
				<i class="feature_worldWonder_medium_flat_black"></i>
				<!-- ngIf: n.data.expireTime > 0 -->
			</a>*/
			/*{
				type: 'clickable',
				icon: 'feature_worldWonder_medium_flat_black',
				time: 0 * 1000,
				expireTime: 0,
				title: 'Игровой раунд завершен',
				count: 0,
				onClick: () => {
					this.$router.push({path: '/world-ended-modal'});
				},
			},
			{
				type: 'clickable',
				icon: 'notification_playerDeletion_medium_flat_red',
				time: ((((((3 * 24) + 12) * 60) + 0) * 60) + 0) * 1000,
				expireTime: 0,
				title: 'Персонаж будет удален через 71:58:19',
				count: 0,
				onClick: () => {
					this.$router.push({path: '/settings', query: {tab: 'profile', subtab: 'avatar'}});
				},
			},
			{
				type: 'disabled',
				icon: 'movement_peace_medium_flat_black',
				time: ((((((1 * 24) + 12) * 60) + 0) * 60) + 0) * 1000,
				expireTime: 0,
				title: 'Перемирие начнется через 71:58:19',
				count: 0,
				onClick: () => {
					
				},
			},
			{
				type: 'disabled',
				icon: 'notification_starvation_medium_flat_black',
				time: ((((((3 * 48) + 12) * 60) + 0) * 60) + 0) * 1000,
				expireTime: 0,
				title: 'Голод будет включен через 71:58:19',
				count: 0,
				onClick: () => {
					
				},
			},
			{
				type: 'clickable',
				icon: 'notification_unitedKingdom_medium_flat_black',
				time: ((((((3 * 48) + 12) * 60) + 0) * 60) + 0) * 1000,
				expireTime: 0,
				title: 'Объединение королевств будет доступно через: 54:57:38',
				count: 0,
				onClick: () => {
					// открывает помощь по игре - королевство - слияние королевств
					// https://ru3.kingdoms.com/#/page:village/pageId:Kingdom_Unions/window:help
					this.$router.push({path: '/help'});
				},
			},*/
		];
	}
}
